export default "__VITE_ASSET__DZMhAZtP__"